// extracted by mini-css-extract-plugin
export default {"grey_text":"styles_grey_text__JHow0","right":"styles_right__NpMTU"};